import React from 'react';
import styles from "./pageError.module.scss";
import {Button} from "antd";

const PageError = () => {

  function closeHandler(event: React.MouseEvent<HTMLButtonElement>) {
    window.location.replace('/')
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.title}>
          <h1>Ошибка</h1>
        </div>
        <div className={[styles.buttonWrap, styles.btnEscape].join(' ')}>
          <Button type={'primary'} onClick={closeHandler}>Назад</Button>
        </div>
      </div>
    </div>
  );
};

export default PageError;